import React from 'react';

// MUI
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

// MUI Icons
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

type CalendarAdornmentProps = {
  disabled: boolean;
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
}

function CalendarAdornment(props: CalendarAdornmentProps) {

  const { disabled, onClick} = props;

  return (
    <InputAdornment position="end">
      <IconButton aria-label="open calendar" onClick={onClick} size="small" disabled={disabled}>
        <CalendarTodayIcon style={{ fontSize: 20 }} color={disabled ? "disabled" : "primary"} />
      </IconButton>
    </InputAdornment>
  );
}

export default CalendarAdornment;